import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Blog.css';

const Blog = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const [headerRef, headerInView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div className="blog-page">
      <section className="blog-header" ref={headerRef}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} md={10}>
              <motion.div
                initial="hidden"
                animate={headerInView ? "visible" : "hidden"}
                variants={fadeIn}
              >
                <h1 className="page-title">Our Blog</h1>
                <p className="lead">
                  Insights and expertise from our team to help you navigate the digital landscape.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="blog-content section-padding">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} md={10}>
              <div className="coming-soon-wrapper text-center">
                <h2>Coming Soon!</h2>
                <p>Our blog is currently under construction. We're working on creating valuable content that will help you navigate the digital landscape and stay informed about the latest trends and best practices in web development, mobile app development, and digital marketing.</p>
                <p>Check back soon for articles, tutorials, case studies, and more!</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Blog; 